import { render, staticRenderFns } from "./InternationDrawer.vue?vue&type=template&id=c0e2767e&scoped=true&"
import script from "./InternationDrawer.vue?vue&type=script&lang=js&"
export * from "./InternationDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e2767e",
  null
  
)

export default component.exports